
import Terms from "./company/Terms";

export { Page }

function Page() {
  return <Terms />;
}
